export default __webpack_public_path__ + "static/media/carb.e7bafb2e.jpg";